import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Gift, Loader2, FileText, Target, Swords, Zap, Coins, Sparkles } from "lucide-react";
import Btn from "../components/Btn";
import api, { apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const ICON = { file: FileText, target: Target, swords: Swords };

export default function Missions() {
  const { refresh } = useAuth();
  const [missions, setMissions] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/missions").then(({ data }) => setMissions(data.missions)).catch(() => {});
  useEffect(() => { load(); }, []);

  const claim = async (id) => {
    setBusy(id);
    try {
      const { data } = await api.post(`/missions/${id}/claim`);
      const r = data.reward;
      const parts = [r.tokens && `+${r.tokens} token`, r.energy && `+${r.energy} energi`, r.exp && `+${r.exp} EXP`].filter(Boolean);
      toast.success(`Hadiah diklaim! ${parts.join(" · ")} 🎁`);
      await refresh(); load();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(null); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="font-heading font-black text-2xl sm:text-3xl flex items-center gap-2"><Gift className="w-7 h-7 text-su-secondary" /> Misi Harian</h1>
        <p className="text-su-muted font-medium">Selesaikan misi tiap hari untuk bonus energi, token, & EXP.</p>
      </div>

      {!missions ? (
        <div className="grid place-items-center py-16"><Loader2 className="w-10 h-10 animate-spin text-su-primary" /></div>
      ) : (
        <div className="space-y-3">
          {missions.map((m) => {
            const Icon = ICON[m.icon] || Sparkles;
            const pct = Math.round((m.progress / m.goal) * 100);
            return (
              <div key={m.id} className="card-chunky p-5 flex items-center gap-4" data-testid={`mission-${m.id}`}>
                <div className={`w-12 h-12 rounded-2xl grid place-items-center shrink-0 ${m.done ? "bg-su-success/15" : "bg-su-primary/10"}`}>
                  <Icon className={`w-6 h-6 ${m.done ? "text-su-success" : "text-su-primary"}`} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-heading font-extrabold">{m.title}</p>
                  <div className="h-2.5 rounded-full bg-su-track mt-1.5 overflow-hidden">
                    <div className="h-full rounded-full bg-su-primary transition-all" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="flex items-center gap-3 mt-1.5 text-xs font-heading font-bold text-su-muted">
                    <span>{m.progress}/{m.goal}</span>
                    {m.reward.tokens && <span className="flex items-center gap-0.5 text-su-secondaryShadow"><Coins className="w-3.5 h-3.5" />{m.reward.tokens}</span>}
                    {m.reward.energy && <span className="flex items-center gap-0.5 text-su-energy"><Zap className="w-3.5 h-3.5 fill-current" />{m.reward.energy}</span>}
                    {m.reward.exp && <span className="flex items-center gap-0.5 text-su-primary"><Sparkles className="w-3.5 h-3.5" />{m.reward.exp}</span>}
                  </div>
                </div>
                {m.claimed ? (
                  <span className="flex items-center gap-1 text-su-success font-heading font-black text-sm shrink-0"><CheckCircle2 className="w-5 h-5" /> Diklaim</span>
                ) : (
                  <Btn size="sm" variant={m.done ? "success" : "ghost"} data-testid={`claim-${m.id}`} disabled={!m.done || busy === m.id} onClick={() => claim(m.id)}>
                    {busy === m.id ? "..." : m.done ? "Klaim" : "Terkunci"}
                  </Btn>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
